package com.patronat.top.ui.organisms.venue

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.atoms.inputs.InputState
import com.patronat.top.ui.models.SelectGroup
import com.patronat.top.ui.models.SelectOption
import com.patronat.top.ui.models.VenueMainInfoData
import com.patronat.top.ui.molecules.inputs.AppInput
import com.patronat.top.ui.molecules.inputs.AppInputMode
import com.patronat.top.ui.molecules.inputs.AppSelectField
import com.patronat.top.ui.molecules.inputs.AppTextArea
import com.patronat.top.ui.theme.MineShaft100
import com.patronat.top.ui.theme.MineShaft950
import com.patronat.top.ui.theme.Primary100
import com.patronat.top.ui.theme.Primary600
import com.patronat.top.ui.theme.VenueDescriptionText
import com.patronat.top.ui.theme.VenueInputLabelText
import com.patronat.top.ui.theme.VenueSectionTitleText
import com.patronat.top.ui.theme.White

@Composable
fun MainInfoSection(
    data: VenueMainInfoData,
    categoryOptions: List<SelectOption> = emptyList(),
    onDataChange: (VenueMainInfoData) -> Unit,
    modifier: Modifier = Modifier,
    title: String = "Основна інформація",
    leadingIcon: Painter? = null,
    nameLabel: String = "Назва закладу",
    categoryLabel: String = "Категорія",
    categoryPlaceholder: String = "Оберіть",
    categoryGroups: List<SelectGroup> = emptyList(),
    categoryGroupIconProvider: (@Composable (SelectGroup) -> Painter?)? = null,
    categorySearchPlaceholder: String? = null,
    categoryEmptyResultsText: String? = null,
    phoneLabel: String = "Номер телефону",
    websiteLabel: String = "Сайт",
    descriptionLabel: String = "Опис",
    descriptionPlaceholder: String? = null,
    nameState: InputState? = null,
    categoryState: InputState? = null,
    phoneState: InputState? = null,
    websiteState: InputState? = null,
    descriptionState: InputState? = null
) {
    Column(
        modifier = modifier
            .fillMaxWidth()
            .background(White, RoundedCornerShape(12.dp))
            .border(1.dp, MineShaft100, RoundedCornerShape(12.dp))
            .padding(16.dp)
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            if (leadingIcon != null) {
                Box(
                    modifier = Modifier
                        .size(36.dp)
                        .background(Primary100, RoundedCornerShape(8.dp)),
                    contentAlignment = Alignment.Center
                ) {
                    Icon(
                        painter = leadingIcon,
                        contentDescription = null,
                        modifier = Modifier.size(18.dp)
                    )
                }
                Spacer(modifier = Modifier.width(8.dp))
            }

            Text(
                text = title,
                style = VenueSectionTitleText,
                color = MineShaft950
            )
        }

        Spacer(modifier = Modifier.height(18.dp))

        Column {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                AppInput(
                    label = nameLabel,
                    labelTextStyle = VenueInputLabelText,
                    value = data.name,
                    onValueChange = { onDataChange(data.copy(name = it)) },
                    forceState = nameState,
                    modifier = Modifier.weight(1f)
                )

                AppSelectField(
                    label = categoryLabel,
                    labelTextStyle = VenueInputLabelText,
                    selectedOption = data.category,
                    options = categoryOptions,
                    onOptionSelected = { onDataChange(data.copy(category = it)) },
                    placeholder = categoryPlaceholder,
                    forceState = categoryState,
                    groupedOptions = categoryGroups,
                    groupIconProvider = categoryGroupIconProvider,
                    searchPlaceholder = categorySearchPlaceholder,
                    emptyResultsText = categoryEmptyResultsText,
                    modifier = Modifier.weight(1f)
                )
            }

            Spacer(modifier = Modifier.height(16.dp))

            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                AppInput(
                    label = phoneLabel,
                    labelTextStyle = VenueInputLabelText,
                    value = data.phone,
                    onValueChange = { onDataChange(data.copy(phone = it)) },
                    forceState = phoneState,
                    inputMode = AppInputMode.Phone,
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Phone),
                    modifier = Modifier.weight(1f)
                )

                AppInput(
                    label = websiteLabel,
                    labelTextStyle = VenueInputLabelText,
                    value = data.website,
                    onValueChange = { onDataChange(data.copy(website = it)) },
                    forceState = websiteState,
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Uri),
                    modifier = Modifier.weight(1f)
                )
            }

            Spacer(modifier = Modifier.height(16.dp))

            AppTextArea(
                label = descriptionLabel,
                labelTextStyle = VenueInputLabelText,
                contentTextStyle = VenueDescriptionText,
                value = data.description,
                onValueChange = { onDataChange(data.copy(description = it)) },
                placeholder = descriptionPlaceholder,
                forceState = descriptionState
            )
        }
    }
}
